export default __webpack_public_path__ + "static/media/06.9fc3ee22.png";